const v = {
  /* helpers */
  animate: '0.3s linear all',

  /* shadows */
  shadow: '0 3px 6px rgba(0,0,0,0.25)',

  /* colors */
  colors: {
    border: '#dedede',
    cta: '#981818',
    ctaAlt: '#D12525',
    dark: '#000',
    dark222: '#2c2c2c',
    dark333: '#333',
    dark444: '#444',
    dark666: '#666',
    dark888: '#888',
    light: '#fff',
    offLight: '#f5f5f5',
    placeholder: '#bcbcbc',
    primary: '#26438c',
    primaryDark: '#102252',
    primaryAlt: '#B9CDFF',
    reviews: '#d77735',
    success: '#B9FFA8',
    successAlt: '#1B5A2E',
    successDark: '#0a441b',
    enabled: '#30d158',
    info: '#f2f8f9',
    infoAlt: '#016a78',
    error: '#ea8d8d',
    errorAlt: '#531919',
    links: '#000',
    linksAlt: '#26438C',
    obi: '#2034D2',
  },
};

export default v;
